module.exports = __webpack_public_path__ + "static/img/iPad.cafb378d.svg";